import axios from 'axios'
import { mutationTypes, actionTypes } from './types'
import getters from './getters'

const state = {
  archiveReports: [],
  archiveRespondentReports: [],
  reportData: {},
  errors: {
    getReports: '',
    getReportById: ''
  },
  loading: {
    getMyReports: false,
    getRespondentReports: false
  },
  reportTitle: '',
  reportId: '',
  reportKey: '',
  pageParams: {
    totalPages: 1,
    totalCount: 0,
    pageIndex: 0,
    pageSize: 10
  }
}

const mutations = {
  GET_MY_REPORTS_SUCCESS(state, payload) {
    state.archiveReports = payload.result
    state.errors.getReports = ''
  },
  GET_MY_REPORTS_ERROR(state, error) {
    state.errors.getReports = error
  },
  GET_REPORT_BY_ID_SUCCESS(state, payload) {
    state.reportData = payload
    state.errors.getReportById = ''
  },
  GET_REPORT_BY_ID_ERROR(state, error) {
    state.errors.getReportById = error
  },
  GET_MY_REPORTS_LOADING(state, payload) {
    state.loading.getMyReports = payload
  },
  SET_REPORT_DATA(state, { title, id, key }) {
    state.reportTitle = title
    state.reportId = id
    state.reportKey = key
  },
  CLEAR_ARCHIVE_REPORT_DATA(state) {
    state.reportData = {}
    state.reportTitle = ''
    state.reportId = ''
    state.reportKey = ''
  },
  [mutationTypes.getRespondentReportsRequest](state) {
    state.loading.getRespondentReports = true
  },
  [mutationTypes.getRespondentReportsSuccess](state, payload) {
    state.archiveRespondentReports = payload.items
    const { totalCount, totalPages, pageIndex, pageSize } = payload
    state.pageParams = { totalCount, totalPages, pageIndex, pageSize }
    state.loading.getRespondentReports = false
  },
  [mutationTypes.getRespondentReportsFailure](state) {
    state.loading.getRespondentReports = false
  },
  [mutationTypes.setPageIndex](state, payload) {
    state.pageParams.pageIndex = payload
  },
  [mutationTypes.setPageSize](state, payload) {
    state.pageParams.pageSize = payload
  }
}

const actions = {
  GET_MY_REPORTS({ commit }) {
    commit('GET_MY_REPORTS_LOADING', true)
    axios({
      method: 'GET',
      url: '/api/report/GetMyReports'
    })
      .then(response => {
        commit('GET_MY_REPORTS_SUCCESS', response.data)
        commit('GET_MY_REPORTS_LOADING', false)
      })
      .catch(error => {
        commit('GET_MY_REPORTS_ERROR', error.response.data)
        commit('GET_MY_REPORTS_LOADING', false)
      })
  },
  GET_REPORT_BY_ID({ commit }, id) {
    return axios({
      method: 'GET',
      url: `/api/report/GetMyReport/${id}`
    })
      .then(response => {
        commit('GET_REPORT_BY_ID_SUCCESS', response.data)
      })
      .catch(error => {
        commit('GET_REPORT_BY_ID_ERROR', error.response.data)
      })
  },
  [actionTypes.getRespondentReports]({ commit, dispatch }, params) {
    commit(mutationTypes.getRespondentReportsRequest)

    const pageData = {
      pageIndex: state.pageParams.pageIndex,
      pageSize: state.pageParams.pageSize
    }

    return axios({
      method: 'GET',
      url: '/api/report/GetRespondentReports2',
      params: { ...pageData, ...params }
    })
      .then(response => {
        commit(mutationTypes.getRespondentReportsSuccess, response.data)
      })
      .catch(error => {
        commit(mutationTypes.getRespondentReportsFailure)
        dispatch('NOTIFICATION', { open: true, color: 'red', text: error.response.data.message })
      })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/archive/index.js